import React, { useRef } from 'react';

// Importing images from the assets folder
import TestimonyImage1 from '../assets/Testimony/TestimonyImage1.png';
import TestimonyImage2 from '../assets/Testimony/TestimonyImage2.png';
import TestimonyImage3 from '../assets/Testimony/TestimonyImage3.png';
import TestimonyImage4 from '../assets/Testimony/TestimonyImage4.png';
import TestimonyImage5 from '../assets/Testimony/TestimonyImage5.png';
import TestimonyImage6 from '../assets/Testimony/TestimonyImage6.png';
import TestimonyImage7 from '../assets/Testimony/TestimonyImage7.png';
import TestimonyImage8 from '../assets/Testimony/TestimonyImage8.png';
import TestimonyImage9 from '../assets/Testimony/TestimonyImage9.png';

function SmallTestimony() {
  const containerRef = useRef(null);

  const handleScrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: -1040, behavior: 'smooth' }); // Scroll by the width of 4 items (250px each)
    }
  };

  const handleScrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: 1040, behavior: 'smooth' }); // Scroll by the width of 4 items (250px each)
    }
  };

  // Array of testimonials with image sources
  const testimonials = [
    { image: TestimonyImage1, name: "David James", role: "CEO/Chairman" },
    { image: TestimonyImage2, name: "Sarah Lee", role: "Founder" },
    { image: TestimonyImage3, name: "James Smith", role: "Marketing Director" },
    { image: TestimonyImage4, name: "Emily White", role: "Product Manager" },
    { image: TestimonyImage5, name: "Michael Brown", role: "CTO" },
    { image: TestimonyImage6, name: "Linda Green", role: "COO" },
    { image: TestimonyImage7, name: "Emily White", role: "Product Manager" },
    { image: TestimonyImage8, name: "Michael Brown", role: "CTO" },
    { image: TestimonyImage9, name: "Linda Green", role: "COO" },
  ];

  return (
    <section className="bg-[#F7F3F2]">
      <div className="mx-auto flex flex-col gap-y-16 px-5 py-24 sm:gap-y-6 md:px-10 relative">
        <h2 className="text-center text-2xl font-bold md:text-3xl text-black">
          HEAR FROM OUR CLIENTS
        </h2>
        <div className="p-6 text-center justify-center">
         
{/* Left Arrow Button */}
<button
              className="absolute top-1/2 left-0 transform -translate-y-1/2 z-10 p-6 pt-28"
              onClick={handleScrollLeft}
            >
              {/* Left Arrow SVG */}
              <svg
                width="50"
                height="50"
                viewBox="0 0 72 73"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="1"
                  width="71"
                  height="71"
                  rx="35.5"
                  stroke="#000000" // White color for the background circle stroke
                />
                <path
                  d="M44 35.5H31.83L37.42 29.91L36 28.5L28 36.5L36 44.5L37.41 43.09L31.83 37.5H44V35.5Z"
                  fill="#000000" // White color for the arrow itself
                />
              </svg>
            </button>

          <div className="relative flex items-center justify-center">
            
            <div
              ref={containerRef}
              className="flex overflow-x-auto gap-28 py-6 scroll-smooth scrollbar-hide max-w-[1040px] w-full" // Limit the width to 4 items
            >
              {testimonials.map((testimonial, index) => (
                <div key={index} className="min-w-[160px]">
                  <img
                    className="object-cover w-[210px] h-[140px]"
                    src={testimonial.image} 
                    alt={`Testimonial ${index + 1}`}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Right Arrow Button */}
          <button
            className="absolute top-1/2 right-0 transform -translate-y-1/2 z-10 p-6 pt-28"
            onClick={handleScrollRight}
          >
            {/* Right Arrow SVG */}
            <svg
              width="50"
              height="50"
              viewBox="0 0 72 73"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="1"
                width="71"
                height="71"
                rx="35.5"
                stroke="#000000" // White color for the background circle stroke
              />
              <path
                d="M36 28.5L34.59 29.91L40.17 35.5H28V37.5H40.17L34.59 43.09L36 44.5L44 36.5L36 28.5Z"
                fill="#000000" // White color for the arrow itself
              />
            </svg>
          </button>
        </div>

        <div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            {/* <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
              READ MORE TESTIMONIALS →
            </button>
            <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
              SEE OUR CASE STUDIES →
            </button> */}
          </div>
        </div>
      </div>

     
    </section>


  );
}

export default SmallTestimony;
